export default __webpack_public_path__ + "static/media/highway.0238d0e3.svg";